import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { InternationalTransferRequirementsFieldType } from '__generated__/GQL';
import * as Form from 'components/_core/form';

import { InternationalTransferDynamicFieldConfig } from '../../types';
import { InternationalTransferDynamicInput } from '../InternationalTransferDynamicInput';
import locales from './locales';

interface InternationalTransferDynamicFormFieldProps
  extends InternationalTransferDynamicFieldConfig {
  label: string;
}

export const InternationalTransferDynamicFormField: FC<
  InternationalTransferDynamicFormFieldProps
> = ({
  label,
  maxLength,
  minLength,
  name,
  refreshRequirementsOnChange,
  required,
  validationRegexp,
  ...field
}) => {
  const form = useFormContext();

  if (
    [
      InternationalTransferRequirementsFieldType.Select,
      InternationalTransferRequirementsFieldType.Radio,
    ].includes(field.type) &&
    !field.valuesAllowed
  ) {
    return null;
  }

  const rules = {
    maxLength: maxLength
      ? {
          message: locales.formatString(locales.maxLength, maxLength),
          value: maxLength,
        }
      : undefined,
    minLength: minLength
      ? {
          message: locales.formatString(locales.minLength, minLength),
          value: minLength,
        }
      : undefined,
    pattern: validationRegexp
      ? {
          message: locales.patternNotMatching,
          value: new RegExp(validationRegexp),
        }
      : undefined,
    required: required && locales.required,
  };

  return (
    <Controller
      control={form.control}
      defaultValue=""
      name={name}
      render={({
        field: { ref, ...formField },
        fieldState: { error, invalid },
      }) => (
        <Form.Field error={error?.message} label={label}>
          <InternationalTransferDynamicInput
            isInvalid={invalid}
            {...formField}
            {...field}
          />
        </Form.Field>
      )}
      rules={rules}
    />
  );
};
